// extracted by mini-css-extract-plugin
module.exports = {"secretWrap":"EditApp_secretWrap__10eIU","secretCopy":"EditApp_secretCopy__3Bet-"};